import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="GSBall" link="https://github.com/Alfonso-Jim/Glued_Shoe_Basketball" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
 <img src="https://alfonso-jim.github.io/img/gsb.gif" style={{
        "WebkitFilter": "brightness(1)",
        "filter": "brightness(1)",
        "display": "block",
        "maxWidth": "100%",
        "maxHeight": "100%",
        "borderRadius": "8px",
        "marginLeft": "auto",
        "marginRight": "auto"
      }} /><p />
 Glued Shoe Basketball! Includes events and handles wadsad
    </ProjectCard>
    <ProjectCard title="Concordian" link="https://github.com/Alfonso-Jim/The_Concordian" bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)" mdxType="ProjectCard">
 <img src="https://alfonso-jim.github.io/img/concordian.jpg" style={{
        "WebkitFilter": "brightness(2)",
        "filter": "brightness(2)",
        "display": "block",
        "maxWidth": "100%",
        "maxHeight": "100%",
        "borderRadius": "8px",
        "marginLeft": "auto",
        "marginRight": "auto"
      }} /><p />
 The university's newspaper website implemented using wordpress in XAMPP
    </ProjectCard>
    <ProjectCard title="2D Kart" link="https://github.com/Alfonso-Jim/Mario_Kart_2D" bg="linear-gradient(to right, #009245 0%, #FCEE21 100%)" mdxType="ProjectCard">
 <img src="https://alfonso-jim.github.io/img/mario.jpg" style={{
        "display": "block",
        "maxWidth": "100%",
        "maxHeight": "100%",
        "borderRadius": "8px",
        "marginLeft": "auto",
        "marginRight": "auto"
      }} /><p />
 A 2D racing game with different feautres: power ups, timers, two players, etc.
    </ProjectCard>
    <ProjectCard title="Alphus OS" link="https://github.com/Alfonso-Jim/Alphus_OS-V-0.1/tree/master/Desktop/College/Concord/Courses/2016%20-%202017/Computer%20Science/OS/Projects/Various%20Attempts/Gui%20Attempts/Alphus_OS%20V%20April/Alphus_OS%20V%200.1" bg="linear-gradient(to right, #D585FF 0%, #00FFEE 100%)" mdxType="ProjectCard">
 <img src="https://alfonso-jim.github.io/img/alphusos.gif" style={{
        "display": "block",
        "maxWidth": "100%",
        "maxHeight": "100%",
        "borderRadius": "8px",
        "marginLeft": "auto",
        "marginRight": "auto"
      }} /><p />
 Alphus_OS implemented with bash, that can do cmds as: exec, date, alias, etc.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      